// @module NXTurn.ShoppingExtensions.IncomingEquipment
define('C3.ShoppingExtensions.IncomingEquipment.View'
,   [
    'c3_shoppingextensions_incomingequipment.tpl'
    
    //, 'NXTurn.ShoppingExtensions.IncomingEquipment.SS2Model'
    ,   'GlobalViews.Breadcrumb.View'
    ,   'C3.ShoppingExtensions.IncomingEquipment.Collection'
    ,   'AjaxRequestsKiller'
    ,   'Backbone.CompositeView'
    ,   'GlobalViews.Pagination.View'
    ,   'GlobalViews.ShowingCurrent.View'
//    ,   'SC.Configuration' 
    ,   'Backbone.CollectionView'
    ,   'Handlebars'
    ,   'C3.ShoppingExtensions.IncomingEquipment.ResultsView'
    //,   'NXTurn.ShoppingExtensions.IncomingEquipment.IEPopupView'
    //,   'NXTurn.ShoppingExtensions.IncomingEquipment.DownloadCSV.Model'
    ,   'UrlHelper'
    ,   'Backbone'
    ,   'Utils'
    ,   'underscore'
    ]
, function (
    c3_shoppingextensions_incomingequipment_tpl
    
    //, IncomingEquipmentSS2Model
    ,   GlobalViewsBreadcrumbView
    ,   IncomingEquipmentCollection
    ,   AjaxRequestsKiller
    ,   BackboneCompositeView
    ,   GlobalViewsPaginationView
    ,   GlobalViewsShowingCurrentView
    //,   Configuration
    ,   BackboneCollectionView
    ,   Handlebars
    ,   IncomingEquipmentSearchDetailResultsView
    //,   IEPopupView
    //,   DownloadCSVModel
    ,   UrlHelper
    ,   Backbone
    ,   Utils
    ,   _
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.IncomingEquipment.View @extends Backbone.View
    return Backbone.View.extend({

        template: c3_shoppingextensions_incomingequipment_tpl

    ,   title : 'Incoming Equipment'
    ,   initialize: function (options) {
        //console.log(options)
            this.application = options.application;
            this.collection = options.collection;
            this.configuration = this.application.Configuration;
            
            this.listenCollection();

            var url_options = Utils.parseUrlOptions(Backbone.history.fragment)
            

            this.page = url_options.page

            BackboneCompositeView.add(this);
        }

    ,   events: {
        'click [data-action="show-ie-popup"]': 'showIEPopup',
        'click [data-action="download-results"]': 'downloadCSV'
    }   

    ,   downloadCSV: function()
    {

        //var url = "https://4953269.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1300&deploy=1&compid=4953269&h=7a0eb1a4a297a9db9288"
        var url = "https://4953269.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1300&deploy=1&compid=4953269&ns-at=AAEJ7tMQLKoI0DxUUlBnv_Re5QQLqJMGG0DVELVaN6-AFmU7jSQ"
        window.location.href = url;
    }

    ,   showIEPopup: function(e)
        {
            
            var $element = jQuery(e.currentTarget);
            var targetValue = $element.attr('data-item-sku');
            //console.log(targetValue)  

            var Layout = SC.Application('Shopping').getComponent('Layout');
            /*var iePopupView = new IEPopupView({
                itemid: targetValue
            });
            if (iePopupView)
                Layout.showContent(iePopupView, {showInModal: true});*/
        }

        //@method listenCollection
    ,   listenCollection: function ()
        {
            this.setLoading(true);

            this.collection.on({
                request: jQuery.proxy(this, 'setLoading', true)
            ,   reset: jQuery.proxy(this, 'setLoading', false)
            });
        }
        
    ,   setLoading: function (value)
        {
            this.isLoading = value;
        }       

    /*, events: {
        'keyup [data-action="incoming-equipment-search"]': 'incomingEquipmentSearch',
        'focusin [data-action="incoming-equipment-search"]': 'incomingEquipmentSearch'
        }*/

    ,   bindings: {
        }

    /*,   incomingEquipmentSearch: function(e) {
        //console.log(e)
        var searchBoxValue=jQuery('#search-ie').val();
        if(searchBoxValue.length>=3){
            this.updateUrl(e);
        }

    }   */
    /*,  updateUrl: function(e){
        let url = Backbone.history.fragment;
        url = UrlHelper.setUrlParameter(url, 'keyword', e.target.value);
        Backbone.history.navigate(url, { trigger: false });

        return this.updateCollection(e.target.value);
     }*/

    ,   childViews: {
            'Global.Breadcrumb': function() {
                var ieBreadcrumbs = [];

                 ieBreadcrumbs[0] = {
                        href : '/',
                        'data-hashtag' : '#',
                        'data-touchpoint': "home",
                        hasDataHashtag: true,
                        hasDataTouchpoint: true,
                        text: "Home"
                  }

                ieBreadcrumbs[1] = {
                     href : '/',
                     text: "Incoming Equipment"
                }

                return new GlobalViewsBreadcrumbView({
                         pages: ieBreadcrumbs 
                    });
            }
        ,   'IncomingEquipment.Results': function() {
             return this._resultsView;
            }
        ,   'GlobalViews.Pagination': function()
            {
                var Pagination = new GlobalViewsPaginationView(_.extend({
                    totalPages: Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage)
                }, this.configuration.defaultPaginationSettings));

                return Pagination;
            }
        ,   'GlobalViews.ShowCurrentPage': function()
            {
                return new GlobalViewsShowingCurrentView({
                    items_per_page: this.collection.recordsPerPage
                ,   total_items: this.collection.totalRecordsFound
                ,   total_pages: Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage)
                });
            }
        }

            // @method setSelecteds set the selected rows from url information
/*  ,   setSelecteds: function ()
        {
            var url_options = _.parseUrlOptions(Backbone.history.fragment)
            ,   currentAppliedFilters = {}
            ,   availableFilters = url_options.keyword
            //,   addedAppliedFilterValue = false


            this.appliedKeyword = url_options.keyword
    
            if(!(this.updatedCollection == true))
            {

                    this.updateCollection(availableFilters);

            }
        }*/     
            // when rendering we need to check
        // if there are options already set up in the url
/*  ,   render: function ()
        {
            //this.updateCollection();
            this.setSelecteds();
            //console.log('render')
            this._render();
        }*/

    /*,  updateCollection: function(purifyAppliedFilters)
        {
            var collection = this.collection;
            
            //console.log(purifyAppliedFilters)
              //@lass Collection.Filter
            collection.update && collection.update({
                //@property {value:String} filter
            //  filter: purifyAppliedFilters
                page: this.page
            ,   keyword : purifyAppliedFilters
                //@property {Number} killerId
            ,   killerId: AjaxRequestsKiller.getKillerId()
            }, this);

            var self = this;

            this.updatedCollection = true;

            setTimeout(function()
                {
                self.render();
                }, 3000)
            //console.log(collection)

            return this;
        }*/         
            
    , _buildResultsView: function() {
            var self = this;
            var selectedColumns = [];
            
           // var stockCollection = this.collection;
            var stockCollection = this.collection.models[0].get('searchResults');
                

            var records_collection = new Backbone.Collection(
                stockCollection.map(function(item) {

                    var values = item.values;
                    var newArray = []

                    var additionalValues = item.additionalValues
                    ,   isonline = false
                    ,   url = ''
                    
                    if(additionalValues.Display_In_WebSite == true){
                        isonline = true;
                        url = additionalValues.Item_URL_Component;
                    }


                    $.each(values, function(key, value) {
                        if(key == 'SKU')
                        {
                           if(isonline == true)
                            value = new Handlebars.SafeString(Utils.translate('<a href="'+url+'" class="sku-link" data-item-sku="$(0)">$(0)</a>', value));                           
                           //value = new Handlebars.SafeString(_('<a href="'+url+'" class="sku-link" data-item-sku="$(0)">$(0)</a>').translate(value))
                          // else   
                          // value = new Handlebars.SafeString(_('<a href="#" class="sku-link" data-item-sku="$(0)" data-action="show-ie-popup">$(0)</a>').translate(value))                        
                        }


                        newArray.push({
                            label : key,
                            value : value/*,
                            id : item.id*/
                            })
                    });

                    //console.log(newArray)

                    var model = new Backbone.Model({
                        id: item.id,
                        recordType: item.recordType,
                        columns : newArray
                    });
                    return model;
                })
            );
            
            this.showTracking = true ;
            if(Backbone.history.fragment.indexOf('estimates') === 0) {
                this.showTracking = false
            }

            //console.log(records_collection)
            
            var returnItem =  new BackboneCollectionView({
                childView: IncomingEquipmentSearchDetailResultsView,
                collection: records_collection,
                viewsPerRow: 1

            });

            //console.log(returnItem);
            return returnItem;
        }   
            
        //@method getContext @return NXTurn.ShoppingExtensions.IncomingEquipment.View.Context
    ,   getContext: function getContext()
        {
            this._resultsView = this._buildResultsView();


            //IncomingEquipment Date Range
            var IncomingEquipmentDateObj = new Date()
            ,   IncomingEquipmentTodaysDate = IncomingEquipmentDateObj.getDate()
            ,   IncomingEquipmentTodaysMonth = IncomingEquipmentDateObj.getMonth()+1
            ,   IncomingEquipmentTodaysDay = IncomingEquipmentDateObj.getDay()

            var IncomingEquipmentDateObj = new Date; 
            var first = IncomingEquipmentDateObj.getDate() - IncomingEquipmentDateObj.getDay(); 
            var last = first + 6; 

            var firstday = new Date(IncomingEquipmentDateObj.setDate(first)).toUTCString()
            ,   firstDayFormatting = new Date(firstday)
            ,   firstdayIncomingEquipmentTodaysDate = firstDayFormatting.getDate()
            ,   firstdayIncomingEquipmentTodaysMonth = firstDayFormatting.getMonth()+1
            ,   finalIncomingEquipmentStartDate = firstdayIncomingEquipmentTodaysMonth+"/"+firstdayIncomingEquipmentTodaysDate
            ,   lastday = new Date(IncomingEquipmentDateObj.setDate(last)).toUTCString()
            ,   lastdayFormatting = new Date(lastday)
            ,   lastdayIncomingEquipmentTodaysDate = lastdayFormatting.getDate()
            ,   lastdayIncomingEquipmentTodaysMonth = lastdayFormatting.getMonth()+1
            ,   finalIncomingEquipmentEndDate = lastdayIncomingEquipmentTodaysMonth+"/"+lastdayIncomingEquipmentTodaysDate
            
            var incomingEquipmentDateRange = finalIncomingEquipmentStartDate+"-"+finalIncomingEquipmentEndDate;


            return {
                //hasAppliedKeyword : this.appliedKeyword ? true : false,
                //appliedKeyword : this.appliedKeyword,
                incomingEquipmentDateRange : incomingEquipmentDateRange,
                responseSuccessStatus : this.collection.models[0].get('responseStatus') == "Success" ? true : false,
                pageResultsColumns : this.collection.models[0].get('searchColLabels'),              
                showPagination: !!(this.collection.totalRecordsFound && this.collection.recordsPerPage),
                collectionLengthGreaterThan0: this.collection.models[0].get('searchResults').length > 0
            };
        }
    });
});
